export default "__VITE_ASSET__h1EC9s9A__"